// --- GLOBAL VARIABLES --- //
var $window = $(window)
var $document = $(document)
var $header = $('.header')
var bpXsmall = 575
var bpSmall = 771
var bpMedium = 992
var bpLarge = 1200
var classIsActive = 'is-active'
var classIsDisabled = 'is-disabled'
var classIsLast = 'is-last'
var classHasError = 'has-error'
var classIsLoading = 'is-loading'
var classIsOpened = 'is-opened'
var classIsSelected = 'is-selected'
var classIsCollapse = 'is-collapse'
var classIsAnimated = 'is-animated'
var $this = null
var $containers = $('html,body')

// --- COMPONENTS, PARTS --- //
$(document).ready(function () {
  // ---  COMPONENTS --- //
  // Modal
  // componentModal()

  // ClipBoard
  componentCopyText()

  // SeparateNumber
  // componentSeparateNumber()

  // Select
  componentSelect()

  // CodeSelect
  componentCodeSelect()

  // LabelsCreate
  componentLabelsCreate()

  // ServiceCreate
  componentServiceCreate()

  // CategoryCreate
  componentCategoryCreate()

  // FAQCreate
  componentFAQCreate()

  // ChartJs
  // componentChartJs()

  // tabs
  componentTabs()

  // Table
  // componentTable()

  // Calendar
  // componentCalendar()

  // // Slider
  // componentSlider()

  // Swiper
  // componentSwiper()

  // Accordion
  componentAccordion()

  // // Textarea Resize
  // componentTextareaResize()
  // Gallery
  componentGallery()

  // // CopyText
  // componentCopyText()

  // Tooltip
  componentTooltip()

  // Navigation
  // componentFullscreenNavigation()

  // Ajax
  // componentAjaxLoad()

  // Validate forms
  // componentValidateForms()

  // sms code
  // componentSmsCodeInput()

  // // show password
  // componentShowPassword()

  // // ---  PART --- //
  // Placeholder
  // partPlaceholder()

  // Scroll to
  partScrollTo()

  // Show Hidden
  // partShowHidden()

  // Dropdown
  partDropdown()

  // // Scroll Resize
  // partScrollResize()

  // // Side navigation
  // componentSideNavigation()
})

// var resizeTimer

// // --- SCROLL EVENT --- //
// $(document).scroll(function () {
//   if (resizeTimer) {
//     window.cancelAnimationFrame(resizeTimer)
//   }

//   resizeTimer = window.requestAnimationFrame(function () {
//     partScrollResize()
//     componentSideNavigation()
//   })
// })

// // --- RESIZE EVENT --- //
// $(window).resize(function () {
//   if (resizeTimer) {
//     window.cancelAnimationFrame(resizeTimer)
//   }

//   resizeTimer = window.requestAnimationFrame(function () {
//     partScrollResize()
//   })
// })

// --- LOAD EVENT --- //
$(window).bind('load', function () {
  // Page Loader
  // $('body').addClass(classIsActive)

  if ($(window).width() < bpSmall) {
    $('.dashboard-list__item.is-active').removeClass(classIsActive)
  }
})
